
export const IssueState = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
};